import CaptureClicks from '@/features/shared/CaptureClicks';
import {
  MuiTable,
  MuiTableBody,
  MuiTableCell,
  MuiTableContainer,
  MuiTableHead,
  MuiTableRow,
  MuiTypography,
} from '@/features/shared/material-ui';
import clsx from 'clsx';
import Markdown from 'markdown-to-jsx';
import React, { memo, useMemo } from 'react';
import useStyles from '../SDLdetail.styles';
import { getFirmwareInfo } from '../SDLdetail.utils';

const CaptureClicksMarkdown = CaptureClicks(Markdown);

const FirmwareInformation = ({ content, labels, deviceType, title = '' }: any) => {
  const classes = useStyles({});
  const footnote = useMemo(
    () => labels?.[`firmware_information_footnote__${deviceType}`] || '',
    [deviceType, labels],
  );
  const hasFootnote = useMemo(() => !!footnote, [footnote]);

  const firmwareInfo: any[] = React.useMemo(
    () =>
      getFirmwareInfo({
        deviceType,
        rawFirmwareInformation: content[0]?.firmware_information?.raw,
      }),
    [content, deviceType],
  );

  const hasFirmwareInfo = React.useMemo(() => !!firmwareInfo.length, [firmwareInfo]);

  const rootClasses = clsx(classes.root, 'basic-firmware-data');

  return (
    <>
      {hasFirmwareInfo && (
        <div className="firmware-detail-heading">
          <MuiTypography variant="h5" component="h5" role="heading" data-testid="sdl-title">
            {title}
          </MuiTypography>
        </div>
      )}
      {hasFirmwareInfo && (
        <MuiTableContainer className={rootClasses}>
          <MuiTable className={classes.table} aria-label="Firmware Information">
            <MuiTableHead>
              <MuiTableRow className={classes.headerRow}>
                {firmwareInfo[0] &&
                  Object.keys(firmwareInfo[0]).map((key) => (
                    <MuiTableCell className={classes.headerCell} key={key + Math.random()}>
                      {labels[key]}
                    </MuiTableCell>
                  ))}
              </MuiTableRow>
            </MuiTableHead>
            <MuiTableBody>
              {firmwareInfo.map((item: any, k: number) => (
                // eslint-disable-next-line react/no-array-index-key
                <MuiTableRow className={classes.bodyRow} key={k + Math.random()}>
                  {Object.keys(item).map((ke) => (
                    <MuiTableCell className={classes.bodyCell} key={ke + Math.random()}>
                      {(item as any)[ke] && Array.isArray((item as any)[ke]) ? (
                        <ul className={classes.bodyCellList}>
                          {(item as any)[ke].map((record: string, key: number) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <li key={key + Math.random()}>{record}</li>
                          ))}
                        </ul>
                      ) : (
                        (item as any)[ke] || 'N/A'
                      )}
                    </MuiTableCell>
                  ))}
                </MuiTableRow>
              ))}
            </MuiTableBody>
          </MuiTable>
        </MuiTableContainer>
      )}
      {hasFootnote && <CaptureClicksMarkdown>{footnote}</CaptureClicksMarkdown>}
    </>
  );
};

export default memo(FirmwareInformation);
